module.exports = __webpack_public_path__ + "img/组5254@2x.15e70767.png";